export const Config = {
  baseURL: process.env.REACT_APP_API_URL,
  socketPath: process.env.REACT_APP_API_SOCKET_PATH,
  socketUrl: process.env.REACT_APP_API_SOCKET_BASE_URL,
};
